export enum TargetTypeEnumFR {
	STARTUP = 'STARTUP',
	PROJET = 'PROJET',
	PME = 'PME',
	ETI = 'ETI',
	FONDS = 'FONDS',
	ENTREPRISE = 'ENTREPRISE',
	IMMOBILIER = 'IMMOBILIER',
	COOPERATIVE = 'COOPERATIVE',
	ENR = 'ENR',
	FORET = 'FORET',
	OPC = 'OPC',
	CLUB_DEAL = 'CLUB_DEAL',
	DONS = 'DONS'
}

export enum TargetTypeEnum {
	STARTUP = 'STARTUP',
	PROJET = 'PROJET',
	PME = 'PME',
	ETI = 'ETI',
	FONDS = 'FONDS',
	COMPANY = 'COMPANY',
	REAL_ESTATE = 'REAL_ESTATE',
	COOPERATIVE = 'COOPERATIVE',
	NRE = 'NRE',
	FOREST = 'FOREST',
	FUNDS = 'FUNDS',
	CLUB_DEAL = 'CLUB_DEAL',
	DONATIONS = 'DONATIONS'
}

export const getTargetTypeFromFR = (e: TargetTypeEnumFR): TargetTypeEnum => {
	switch (e) {
		case TargetTypeEnumFR.STARTUP:
			return TargetTypeEnum.STARTUP;
		case TargetTypeEnumFR.COOPERATIVE:
			return TargetTypeEnum.COOPERATIVE;
		case TargetTypeEnumFR.PROJET:
			return TargetTypeEnum.PROJECT;
		case TargetTypeEnumFR.PME:
			return TargetTypeEnum.SMB;
		case TargetTypeEnumFR.ETI:
			return TargetTypeEnum.MID_CAP;
		case TargetTypeEnumFR.FONDS:
			return TargetTypeEnum.FUND;
		case TargetTypeEnumFR.CLUB_DEAL:
			return TargetTypeEnum.CLUB_DEAL;
		case TargetTypeEnumFR.DONS:
			return TargetTypeEnum.DONATIONS;
	}
};

export const getTargetTypeArrayFromFR = (a: TargetTypeEnumFR[]): TargetTypeEnum[] => {
	const targetTypeEnums: TargetTypeEnum[] = [];
	a.forEach((e) => {
		targetTypeEnums.push(getTargetTypeFromFR(e));
	});
	return targetTypeEnums;
};

export const getTargetTypeFromEN = (e: TargetTypeEnum): TargetTypeEnumFR => {
	switch (e) {
		case TargetTypeEnum.STARTUP:
			return TargetTypeEnumFR.STARTUP;
		case TargetTypeEnum.COOPERATIVE:
			return TargetTypeEnumFR.COOPERATIVE;
		case TargetTypeEnum.PROJECT:
			return TargetTypeEnumFR.PROJET;
		case TargetTypeEnum.SMB:
			return TargetTypeEnumFR.PME;
		case TargetTypeEnum.MID_CAP:
			return TargetTypeEnumFR.ETI;
		case TargetTypeEnum.FUND:
			return TargetTypeEnumFR.FONDS;
		case TargetTypeEnum.CLUB_DEAL:
			return TargetTypeEnumFR.CLUB_DEAL;
		case TargetTypeEnum.DONATIONS:
			return TargetTypeEnumFR.DONS;
	}
};

export const getTargetTypeArrayFromEN = (a: TargetTypeEnum[]): TargetTypeEnumFR[] => {
	const targetTypeEnums: TargetTypeEnumFR[] = [];
	a.forEach((e) => {
		targetTypeEnums.push(getTargetTypeFromEN(e));
	});
	return targetTypeEnums;
};
